import type { ReactNode } from "react";
import { cn } from "./cn";

/** A page's title, its one-line description and its actions (the mock's .page-head). */
export function PageHeader({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        "mb-[22px] flex flex-col items-start justify-between gap-5 md:flex-row",
        className,
      )}
    >
      <div className="min-w-0">
        <h1 className="text-xl tracking-[-0.02em]">{title}</h1>
        {description && <p className="mt-[5px] max-w-[72ch] text-ink-2">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
